/**
 * Thin PostHog analytics wrapper.
 * All functions are no-ops when VITE_POSTHOG_KEY is not set (local dev).
 *
 * Usage:
 *   import { initAnalytics, identifyUser, trackEvent, resetAnalytics } from './analytics'
 *   initAnalytics()                          // once at app startup
 *   identifyUser(userId, email)              // after login
 *   trackEvent('project_created', { type })  // on key actions
 *   resetAnalytics()                         // on sign out
 */

let posthog = null

export function initAnalytics() {
  const key = import.meta.env.VITE_POSTHOG_KEY
  const host = import.meta.env.VITE_POSTHOG_HOST
  if (!key) return

  import('posthog-js').then(({ default: ph }) => {
    ph.init(key, {
      api_host: host || 'https://us.i.posthog.com',
      autocapture: false,
      capture_pageview: false,
      persistence: 'localStorage',
      disable_session_recording: true,
    })
    posthog = ph
  })
}

export function identifyUser(userId, email) {
  if (!posthog) return
  posthog.identify(userId, { email })
}

export function trackEvent(eventName, properties = {}) {
  if (!posthog) return
  posthog.capture(eventName, properties)
}

export function resetAnalytics() {
  if (!posthog) return
  posthog.reset()
}
